export default "__VITE_ASSET__DVPl$OsL__"